import AuthPages from 'modules/auth/containers/AuthPages';
import { useSignIn } from 'modules/auth/containers/AuthPages/hooks/useSignIn';
import Layout from 'ui/Layout';
import SEO from 'ui/SEO';

export default function SigninPage() {
  const { loading, errors, resetErrors, onSubmit } = useSignIn();

  return (
    <Layout showFooter={false} showLinks={false}>
      <SEO title="Sign in" />
      <AuthPages
        pageName="signin"
        loading={loading}
        errors={errors}
        resetErrors={resetErrors}
        onSubmit={onSubmit}
      />
    </Layout>
  );
}
